import { useMemo } from "react";
import { createTheme } from "@mui/material/styles";

const useLightTheme = () => {
  const theme = useMemo(() => {
    return createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#8F29D0",
          light: "#42a5f5",
          dark: "#1565c0",
          contrastText: "#fff",
        },
        secondary: {
          main: "#9c27b0",
          light: "#ba68c8",
          dark: "#7b1fa2",
          contrastText: "#fff",
        },
        background: {
          default: "#ffffff", // White background
          paper: "#ffffff", // White for paper components
        },
        text: {
          primary: "#000000",
          secondary: "#555555",
        },
      },
      shadows: Array(25).fill("none"), // Removes all shadows
      shape: {
        borderRadius: 0, // Optional: No rounded corners
      },
    });
  }, []);

  return { theme };
};

export default useLightTheme;
